const GetResume = ({ button, buttonName, onClick, disabled }) => {
  const { defaultColor } = button;
  return (
    <button
      disabled={disabled}
      className="text-white font-semibold text-center border-0 rounded md:rounded-lg text-lg w-full lg:w-fit py-4 px-6 md:px-24 inline-block"
      style={{ background: defaultColor }}
      onClick={onClick}
    >
      {buttonName}
    </button>
  );
};
export default GetResume;
